// Button.stories.js
import { Dot } from './Dot';

export default {
  title: 'Example/Dot',
  component: Dot,
  parameters: {
    layout: 'centered',
  },
  tags: ['autodocs'],
  argTypes: {
    backgroundColor: { control: 'color' },
  },
};

const Template = (args) => <Dot {...args} />;

const PrimaryAgrs = {
  circleColor: '#FF3250',
  outlineColor: '#FFCCCF',
};

export const PrimaryDotWithOutline = (props) => <Template {...PrimaryAgrs} {...props} />;

const SuccessArgs = {
  circleColor: '#17B26A',
  outlineColor: '#DCFAE6',
};

export const SuccessDotWithOutline = (props) => <Template {...SuccessArgs} {...props} />;
